import ButtonTypes from './buttonTypes';

const PrinterTasksStatus = {
  0: 'Waiting',
  1: 'Queued',
  2: 'Spooled',
  3: 'Printing',
  4: 'Printed',
  5: 'Error',
  6: 'Removed',
  7: 'TimeOut',
  10: 'ServiceStarted',
  11: 'ServiceRunning',
  13: 'HaveNoPrinter',
};

export const PrinterTasksStatusColor = {
  0: ButtonTypes.DANGER,
  1: ButtonTypes.INFO,
  2: ButtonTypes.SECONDARY,
  3: ButtonTypes.SECONDARY,
  4: ButtonTypes.INFO,
  5: ButtonTypes.WARNING,
  6: ButtonTypes.SECONDARY,
  7: ButtonTypes.WARNING,
  10: ButtonTypes.SECONDARY,
  11: ButtonTypes.SECONDARY,
  13: ButtonTypes.SECONDARY,
};

export default PrinterTasksStatus;
